import React from 'react'

interface ProductListSkeletonProperties {
  /** How many placeholder cards to render — must match the number of products about to arrive. */
  count: number
}

/**
 * Height-accurate placeholder for the product grid.
 *
 * Deliberately reuses the real `.cmp-product-list` / `.cmp-product-list-item` class names so the
 * per-breakpoint card widths, gaps and the image's `aspect-ratio: 1 / 1` all apply unchanged. That
 * makes the reserved height match the resolved grid without duplicating any geometry, so swapping
 * the skeleton for real cards produces no layout shift.
 *
 * The empty `__variant` and `__colors-list` rows are intentional: they are constant-height in the
 * real card (a hidden variant only sets `visibility: hidden`), so omitting them would make the
 * placeholder too short.
 */
const ProductListSkeleton: React.FC<ProductListSkeletonProperties> = ({ count }) => {
  return (
    <ul className="cmp-product-list cmp-product-list--is-skeleton" aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <li className="cmp-product-list-item cmp-product-list-item--is-skeleton" key={index}>
          <div className="cmp-product-list-item__image" />
          <div className="cmp-product-list-item__variant cmp-product-list-item__variant--is-hidden">
            <i className="ri-information-line" />
          </div>
          <ul className="cmp-product-list-item__colors-list">
            <li className="cmp-product-list-item__color" data-index={0} />
          </ul>
          <div className="cmp-product-list-item__title">&nbsp;</div>
        </li>
      ))}
    </ul>
  )
}

export default ProductListSkeleton
